import CloseIcon from '@material-ui/icons/Close';
import { Dialog, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { FunctionComponent } from 'react';

import { FooterButton } from '../../pages/NewWork/components/FooterButtons/styled';
import {
    DialogActions as StyledDialogActions,
    DialogContent as StyledDialogContent,
    DialogContentText as StyledDialogContentText,
    dialogPaperProps,
    DialogTitle as StyledDialogTitle
} from '../../pages/NewWork/components/styled';
import { colors } from '../../theme';

const CloseButton = styled(IconButton)({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: colors.white,
    '&:hover': {
        backgroundColor: colors.darkGray
    }
});

export interface WorkDialogButton {
    label: string;
    onClick: () => void;
}

interface WorkDialogProps {
    open: boolean;
    title: string;
    description: string | string[];
    buttons: WorkDialogButton[];
    onClose?: () => void;
    showCloseButton?: boolean;
}

const WorkDialog: FunctionComponent<WorkDialogProps> = ({
    open,
    title,
    description,
    buttons,
    onClose,
    showCloseButton = true
}) => {
    const paragraphs = Array.isArray(description) ? description : [ description ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={dialogPaperProps}
            maxWidth="sm"
            fullWidth
        >
            {showCloseButton && onClose && (
                <CloseButton onClick={onClose}>
                    <CloseIcon />
                </CloseButton>
            )}
            <StyledDialogTitle>{title}</StyledDialogTitle>
            <StyledDialogContent>
                {paragraphs.map((text, i) => (
                    <StyledDialogContentText key={i}>{text}</StyledDialogContentText>
                ))}
            </StyledDialogContent>
            <StyledDialogActions>
                {buttons.map(({ label, onClick }) => (
                    <FooterButton key={label} onClick={onClick}>
                        {label}
                    </FooterButton>
                ))}
            </StyledDialogActions>
        </Dialog>
    );
};

export default WorkDialog;
